<template>
  <div>
    <router-link class="navbar-item" active-class="is-active" :to="{ name: 'index' }" exact>
      <span class="icon is-small">
        <i class="mdi mdi-view-dashboard-outline"></i>
      </span>
      <span>Инфопанели</span>
    </router-link>

    <router-link class="navbar-item" active-class="is-active" :to="{ name: 'indicators' }">
      <span class="icon is-small">
        <i class="mdi mdi-lightbulb-outline"></i>
      </span>
      <span>Индикаторы</span>
    </router-link>

    <router-link class="navbar-item" active-class="is-active" :to="{ name: 'constructor' }">
      <span class="icon is-small">
        <i class="mdi mdi-chart-bar-stacked"></i>
      </span>
      <span>Конструктор чартов</span>
    </router-link>

    <!-- INFO Зкомменчено -->
    <!-- <div class="navbar-item has-dropdown is-hoverable">
      <a class="navbar-link is-arrowless">О системе</a>

      <div class="navbar-dropdown">
        <a class="navbar-item">Новости</a>
        <a class="navbar-item">Публикации</a>
        <a class="navbar-item">Контакты</a>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Navigation'
};
</script>

<style lang="scss" scoped>
.icon {
  margin-right: 0.3rem;
}

.tag {
  margin-left: 0.5rem;
}
</style>
